import DonutChart from './donutChart.component';

export default DonutChart;